<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2025-05-30 16:03:29
-->
<template>
  <div class="home">
    <div id="topbar" v-show="!$route.meta.hiddenNav" >
      <div class="w1200 topbar" >
        <div>
          <b>您好，<span v-if="realName!==''">{{realName}}， </span>欢迎光临河北省建设工程招标代理机构业务培训平台 </b>
          <span class="localtion" style="padding-left:6px"><i class="el-icon-location-information"></i><b>{{formLocal.ssCity=='全部'?'河北省':formLocal.ssCity}}</b>
            <el-popover
              placement="bottom"
              @show='showlocal'
              width="300"
              trigger="click">
              <el-form :inline="true" :model="formLocal" class="demo-form-inline" style="padding:20px 0 0 15px">
                <el-form-item label="选择省份">
                  <el-select v-model="formLocal.ssProvince" placeholder="选择省份" @change="changelocalP" disabled>
                    <el-option v-for="item in localoptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="选择地区">
                  <el-select v-model="formLocal.ssCity" placeholder="选择地区" @change="changelocalS">
                    <el-option v-for="item in cityoptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <a slot="reference">[ 切换地区 ]</a>
            </el-popover>
          </span>
          <span v-if="realName!==''" @click="backClick" style="margin-left:20px;cursor: pointer;">退出</span>
          <!-- <span @click="logresg(1)">登录 </span> -->
          <!-- <b>丨</b>
          <span @click="logresg(2)"> 免费注册</span> -->
        </div>
        <div v-if="realName!==''" class="logined">
          <span class="inspan" @click="resetPassword"><img :src="password" height="13" /> 修改密码</span>
          <!-- 原样式 -->
          <span class="inspan" @click="tonotice" v-if="true">
            <img :src="notice" height="13" /> 我的消息 <el-badge v-if="noticeCount>0" :value="noticeCount"></el-badge>
          </span>
          <!-- 新样式，带下弹框，分不同类型消息 -->
          <el-popover placement="bottom" width="220" trigger="hover" v-else>
            <div class="noticebox">
              <h3>消息（{{noticeCount>0?'noticeCount':'0'}}）</h3>
              <ul>
                <li>
                  <div class="up">
                    <div class="img"><img :src="noticeicon" /></div>
                    <p><b>系统通知系统通知</b></p>
                    <span>02-14 14:21</span>
                  </div>
                  <div class="down">
                    <p>很遗憾，本次考试未通过未通过未通过</p>
                    <a href="###">查看详情</a>
                  </div>
                </li>
                <li>
                  <div class="up">
                    <div class="img"><img :src="noticeicon" /></div>
                    <p><b>系统通知系统通知</b></p>
                    <span>02-14 14:21</span>
                  </div>
                  <div class="down">
                    <p>很遗憾，本次考试未通过！</p>
                    <a href="###">查看详情</a>
                  </div>
                </li>
              </ul>
              <el-button size="small" type="primary" icon="el-icon-chat-dot-round" plain>前往我的消息</el-button>
            </div>
            <span class="inspan" slot="reference"><img :src="notice" height="13" /> 我的消息 <el-badge v-if="noticeCount>0" :value="noticeCount"></el-badge></span>
          </el-popover>
          <span class="inspan" @click="myPlanClick(1)"><img :src="my" height="13" /> 用户中心</span>
          <span class="inspan" @click="toCertificate"><img :src="certificate" height="13" /> 证书公示</span>
        </div>
        <div v-if="realName===''" class="reglog">
          <!-- <span @click="register">企业注册 </span> -->
          <!-- <span style="padding-left:15px" @click="userReg">个人注册 </span> -->
           <span @click="register">登录 </span>
          <!-- <span style="padding-left:15px" @click="logresg(1)">登录 </span> -->
          <span style="padding-left:15px" @click="toCertificate">证书公示</span>
        </div>
      </div>
    </div>
    <div id="logosearch">
      <div class="w1200" v-show="!$route.meta.hiddenNav">
        <router-link to="/index"><img class="logo" :src="logo" height="40" /></router-link>
        <div class="search">
          <el-input style="width: 300px" placeholder="请输入您想查询的关键字" v-model="teachingName" class="input-with-select"></el-input>
          <el-button type="primary" class="searchbtn" size="small" @click.prevent="search"><img :src="searchicon" height="12" /></el-button>
        </div>
        <div style="clear: both"></div>
        <!-- <div class="allclass" @mouseenter="navmouseOver" @mouseleave="navmouseLeave">
          所有课程分类
        </div>
        <div class="topnav">
          <router-link to="/index"><i class="el-icon-s-home"></i> 首页
          </router-link>
          <router-link to="/examination"><i class="el-icon-s-home"></i> 在线考试
          </router-link>
        </div>
        <div class="search">
          <el-input style="width: 300px" placeholder="请输入您想查询的关键字" v-model="teachingName" class="input-with-select"></el-input>
          <el-button type="primary" class="searchbtn" size="small" @click.prevent="search"><img :src="searchicon" height="12"/></el-button>
        </div>
        <div style="clear: both"></div>
        菜单 -->
      </div>
      <div class="w1200" v-show="$route.meta.hiddenNav&&$store.state.showBtn">
        <div class="sea-title">在线考试</div>
        <div style="clear: both"></div>
      </div>
    </div>
    <div class="nav" v-show="!$route.meta.hiddenNav">
      <div class="w1200">
        <router-link to="/index" :class="navindex == -1?'on':''">首页</router-link>
        <a v-for="(item, index) in leftnavarr" :key="index" @click="tolist(item,index)" :class="navindex == index?'on':''">
          {{
            item.typeName
          }}
        </a>
        <router-link v-if="$store.state.showBtn" to="/questionBank" :class="navindex == -3?'on':''">考试题库</router-link>
        <router-link  v-if="$store.state.showBtn" to="/examination" :class="navindex == -4?'on':''">在线考试</router-link>
        <router-link  v-if="realName!==''&&$store.state.showBtn" to="/queryResults" :class="navindex == -5?'on':''">查询成绩</router-link>
      </div>
    </div>
    <div class="w1200" v-show="localpath == 'index'&& realName!==''">
      <div class="rightnav">
        <!-- <div>
          <el-button type="primary" class="loginBtn" @click="loginClick">登录</el-button>
        </div> -->
        <div class="box1">
          <div>
            <img  @click="myPlanClick(1)" :src="!userInfo.headUrl?headUrl:minioUrl+userInfo.headUrl" class="img1">
            <span class="nameText"  @click="myPlanClick(1)">{{realName}}</span>
            <span class="backText" @click="backClick">退出</span>
          </div>
          <div class="inner1">
            <div class="personcount">
              <div class="text1">我的课程数 <b style="font-size:15px">{{userInfo.coursesSum}}</b> <!-- <el-badge :value="userInfo.coursesSum" class="item"></el-badge>-->
              </div>
              <div class="text1">单位课程数 <b style="font-size:15px">{{userInfo.orgCoursesSum}}</b><!-- <el-badge :value="userInfo.orgCoursesSum" class="item"></el-badge>-->
              </div>
            </div>
            <template v-if="courseList.length>0">
              <!-- <li v-for="item in courseList" :key="item.id" @click="todetail(item.teachingtype, item.teachingId, item.teachingName)"><i class="el-icon-collection"></i> {{item.teachingName}}</li> -->
              <li class="li" v-for="item in courseList" :key="item.id" @click="todetail(item.teachingtype, item.teachingId, item.teachingName)">
                <div class="left">
                  <div class="name">{{item.teachingName}}</div>
                  <div class="comp">{{item.deptName}}</div>
                </div>
                <div class="right">
                  <el-button @click="todetail(item.teachingtype, item.teachingId, item.teachingName)" type="warning" size="mini" plain>继续学习</el-button>
                </div>
              </li>
            </template>
          </div>
        </div>
        <el-button type="primary" icon="el-icon-collection" plain class="loginBtn" @click="myPlanClick">前往我的课表</el-button>
      </div>
    </div>
    <!-- 子级 -->
    <div style="min-height:calc(100vh - 239px); margin:0px auto;">
      <router-view />
    </div>
    <div id="footer" :style="{display:showfoot?'block':'none'}">
      <div class="w1200 footer">
        <img :src="wlogo" style="float:left" height="40"/>
        <img src="http://www.hebztb.com/resource/site_1/zbt/img/ba.png" style="vertical-align: middle;margin-right:5px;"> 冀公网安备 13010502001464号 | 备案登记号:
        冀ICP备11005996号-1<span style="padding-left:10px">客服电话：0311-86273887，0311-87820486</span>
      </div>
    </div>
    <loginregister ref="loginregister" @getUser="getUser"></loginregister>
    <userregister ref="userregister"></userregister>
    <resetpassword ref="resetpassword"></resetpassword>
    <div class="instructionshadow" v-if="instructdialog">
      <div>
        <div class="title">
          招标代理机构从业人员考试须知
          <img :src="close" @click="instructdialog=false">
        </div>
        <div style="padding:14px">
          <instructions></instructions>
        </div>
      </div>
    </div>
    <!-- 必填身份证号 -->
    <el-dialog :visible.sync="visible" title="请完善您的信息" :close-on-click-modal="false" :close-on-press-escape="false" :show-close='false' width="1000px">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm"  label-width="110px">
       <personaledit ref="personaledit" :dataForm='dataForm' :iseditcard='true'></personaledit>
      </el-form>
      <template slot="footer">
        <el-button type="danger" plain @click="backClick" :loading='btnload'>退出登录</el-button>
        <el-button type="primary" @click="dataFormSubmitHandle()" :loading='btnload'>提 交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import personaledit from './personaledit'
import Cookies from 'js-cookie'
import userregister from '@/components/userregister'
import loginregister from '@/components/loginregister'
import resetpassword from '@/components/resetpassword'
import instructions from '@/views/exam/components/instructions.vue'
import mixins from '@/mixins/index'
export default {
  mixins: [mixins],
  name: 'Home',
  data () {
    return {
      formLocal: {
        ssProvince: '130000',
        ssCity: '石家庄'
      },
      dataForm: {
        id: '',
        username: '',
        headUrl: '',
        deptId: '',
        deptName: '',
        password: '',
        comfirmPassword: '',
        realName: '',
        gender: 0,
        email: '',
        mobile: '',
        idCard: ''
      },
      btnload: false,
      homeindex: 0,
      teachingName: '',
      minioUrl: '',
      logo: require('@/assets/img/logo.png'),
      wlogo: require('@/assets/img/wlogo.png'),
      headUrl: require('@/assets/img/touxiang.png'),
      my: require('@/assets/img/my.png'),
      password: require('@/assets/img/password.png'),
      notice: require('@/assets/img/notice.png'),
      certificate: require('@/assets/img/certificate.png'),
      searchicon: require('@/assets/img/searchicon.png'),
      noticeicon: require('@/assets/img/sysnoticeicon.png'),
      close: require('@/assets/img/close.png'),
      navindex: '-1',
      leftnavarr: [],
      // shownav: false,
      localpath: '',
      route: {},
      userInfo: {},
      realName: '',
      courseList: [],
      noticeCount: '',
      showfoot: false,
      instructdialog: false,
      visible: false,
      localoptions: [],
      cityoptions: []
    }
  },
  components: { userregister, loginregister, instructions, resetpassword, personaledit },
  watch: {
    $route: {
      handler (to) {
        this.showfoot = false
        if (to.path === '/index') {
          this.$store.dispatch('setNavIndex', '-1')
          this.homeindex++
          // this.shownav = true
          this.localpath = 'index'
          if (this.homeindex > 1) {
            this.getCourse()
          }
        } else {
          this.localpath = ''
          // this.shownav = false
        }
        // 第一次登录，默认石家庄
        if (!localStorage.getItem('cityname')) {
          localStorage.setItem('cityname', '石家庄')
          localStorage.setItem('citycode', '130100')
          this.formLocal.ssCity = '石家庄'
        } else {
          this.formLocal.ssCity = localStorage.getItem('cityname')
        }
        setTimeout(() => {
          this.showfoot = true
          this.navindex = this.$store.state.navIndex
        }, 200)
      },
      immediate: true
    }
  },
  computed: {
    dataRule () {
      var validatePassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error('必填项'))
        }
        callback()
      }
      var validateComfirmPassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error('必填项'))
        }
        if (this.dataForm.password !== value) {
          return callback(new Error('密码不一致'))
        }
        callback()
      }
      var validateEmail = (rule, value, callback) => {
        if (!this.isEmail(value)) {
          return callback(new Error('格式不正确'))
        }
        callback()
      }
      var validateMobile = (rule, value, callback) => {
        if (!this.isMobile(value)) {
          return callback(new Error('格式不正确'))
        }
        callback()
      }
      var validateCardNo = (rule, value, callback) => {
        if (!this.isCardNo(value)) {
          return callback(new Error('格式不正确'))
        }
        callback()
      }
      return {
        username: [
          { required: true, message: '必填项', trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        gender: [
          { required: true, trigger: ['blur', 'change'] }
        ],
        comfirmPassword: [
          { validator: validateComfirmPassword, trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '必填项', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '必填项', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '必填项', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '必填项', trigger: 'blur' },
          { validator: validateCardNo, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.minioUrl = process.env.VUE_APP_minio
    this.getnav()
    // console.log(this.$route)

    // this.getUser()
    // 有登陆信息
    if (localStorage.getItem('user')) {
      this.yztoekn()
      if (!JSON.parse(localStorage.getItem('user')).idCard) {
      // 没有身份证号，强行必填
        this.dataForm = JSON.parse(localStorage.getItem('user'))
        this.visible = true
      }
    } else {
      this.realName = ''
    }

    // 弹出考试须知
    // if (this.localpath === 'index' && localStorage.getItem('user')) {
    //   this.instructdialog = true
    // }
  },
  mounted () {
    // this.route = JSON.stringify(this.$route)
    // console.log(this.$route)

    // var _beforeUnloadTime = 0; var _gapTime = 0
    // window.onunload = function () {
    //   _gapTime = new Date().getTime() - _beforeUnloadTime
    //   console.log(_gapTime)
    //   if (_gapTime <= 5) {
    //     // 浏览器关闭
    //     localStorage.removeItem('webtoken')
    //     localStorage.removeItem('user')
    //   } else {
    //     // 刷新
    //   }
    // }
    // window.onbeforeunload = function () {
    //   _beforeUnloadTime = new Date().getTime()
    // }
  },
  methods: {
    // 表单提交
    dataFormSubmitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.btnload = true
        this.$post('/client/personalCenter/editUserInfo', this.dataForm).then((res) => {
          this.btnload = false
          if (res.code === 0) {
            this.$message.success('操作成功')
            let user = JSON.parse(localStorage.getItem('user'))
            user.headUrl = this.dataForm.headUrl
            user.idCard = this.dataForm.idCard
            localStorage.setItem('user', JSON.stringify(user))
            this.visible = false
          } else {
            this.$message.error(res.msg)
          }
        }).catch(() => {})
      })
    },
    yztoekn () {
      this.$post('/training/trainorganization/verifyLoginInvalid').then(
        (res) => {
          if (res.code === 0) {
            let user = JSON.parse(localStorage.getItem('user'))
            this.realName = user.realName
            this.getNotice()
            this.getCourse()
          } else {
            localStorage.removeItem('webtoken')
            localStorage.removeItem('user')
            // this.$message.warning('您的登录状态已失效，请重新登录')
            this.realName = ''
            // setTimeout(() => {
            //   location.reload()
            // }, 1000)
            // this.$alert('您的登录状态已失效，请重新登录', '提示', {
            //   confirmButtonText: '确定',
            //   callback: action => {
            //     location.reload()
            //   }
            // })
          }
        }
      )
    },
    setRoute () {
      // this.route = this.$route
    },
    toCertificate () {
      this.$router.push({ path: '/certificate' })
    },
    tonotice () {
      this.noticeCount = '0'
      this.$router.push({ path: '/myplan', query: { activeName: 'fifth' } })
    },
    getNotice () {
      this.$get('/training/customerService/getTotalMsg').then((res) => {
        if (res.code === 0) {
          this.noticeCount = res.data
        }
      })
    },
    getCourse () {
      this.$get('/client/home/getHomePersonalInfo?ssProvince=130000&ssCity=' + localStorage.getItem('citycode')).then(res => {
        if (res.code === 0) {
          this.userInfo = res.data.userInfoDTO
          this.courseList = res.data.studyRecordsList
        }
      })
    },
    getnav () {
      this.$get('/clientNotAuth/tree').then((res) => {
        if (res.code === 0) {
          this.leftnavarr = res.data
          localStorage.setItem('leftnavarr', JSON.stringify(res.data))
        }
      })
    },
    // 获取用户信息
    getUser () {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user !== null) {
        this.realName = user.realName
      }
    },
    logresg (val) {
      this.$refs.loginregister.init(val)
    },
    resetPassword () {
      this.$refs.resetpassword.init()
    },
    register () {
      window.open('http://zbdl.hbeba.com:8090/admin?type=3')
    },
    userReg () {
      this.$refs.userregister.init()
    },
    // mouseOver (index) {
    //   this.navindex = index
    // },
    // mouseLeave () {
    //   this.navindex = ''
    // },
    search () {
      this.$store.dispatch('setNavIndex', '-2')
      this.$router.push({
        path: '/list',
        query: { teachingName: this.teachingName }
      })
    },
    tolist (item, index) {
      this.$store.dispatch('setNavIndex', index)
      this.$router.push({ path: '/list', query: { selectId: item.id } })
    },
    // navmouseOver () {
    //   if (this.localpath !== 'index') {
    //     this.navindex = ''
    //     this.shownav = true
    //   }
    // },
    // navmouseLeave () {
    //   if (this.localpath !== 'index') {
    //     this.shownav = false
    //   }
    // },
    // 点击登录按钮
    // loginClick () {
    //   this.isLogin = true
    // },
    // 点击退出按钮
    backClick () {
      this.$confirm('确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('/logout').then((res) => {
          if (res.code === 0) {
            this.realName = ''
            Cookies.remove('webtoken')
            localStorage.removeItem('webtoken')
            localStorage.removeItem('user')
            location.reload()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // 点击我的课表
    myPlanClick (val) {
      if (val === 1) {
        this.$router.push({ path: '/myplan' })
      } else {
        this.$router.push({ path: '/myplan', query: { activeName: 'first' } })
      }
    },
    todetail (selectId, id, teachingName) {
      this.$router.push({
        path: '/detail',
        query: { selectId: selectId, tid: id, tName: teachingName }
      })
    },
    changelocalP (val) {
      // 记得清空市区
      if (val) {
        this.getCity(val)
      }
    },
    changelocalS (val) {
      if (val || val === '') {
        localStorage.setItem('citycode', val)
        localStorage.setItem('cityname', this.cityoptions.filter(item => item.code === val)[0].name)
        location.reload()
      }
      // 记得本地存储市区code，刷新页面
    },
    showlocal () {
      this.$get('/training/trainregion/code/130000').then((res) => {
        if (res.code === 0) {
          this.localoptions = res.data
          this.getCity('130000')
        }
      })
    },
    getCity (code) {
      this.$get('/training/trainregion/parentCode/' + code).then((res) => {
        if (res.code === 0) {
          this.cityoptions = [{ code: '', name: '全部' }, { code: '000000', name: '省级' }, ...res.data]
        }
      })
    }
  }
}
</script>
<style scoped>
.home {
  min-height: 100vh;
}
.sea-title {
  height: 64px;
  line-height: 64px;
  color: #2977ee;
  font-size: 30px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #2977ee;
}
#topbar {
  width: 100%;
  height: 40px;
  background: #f9f9f9;
  position: relative;
  border-bottom: 1px solid #eee;
}
.topbar {
  display: flex;
  justify-content: space-between;
}
.topbar b {
  color: #4a4a4a;
  line-height: 40px;
}
.topbar .inspan {
  color: #4a4a4a;
  line-height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.topbar span:hover {
  color: #409eff;
}
.search {
  padding: 11px 0;
  float: right;
  position: relative;
}
.searchbtn {
  position: absolute;
  z-index: 22;
  top: 15px;
  right: 4px;
}
.logo {
  margin-top: 12px;
  float: left;
}
#footer {
  width: 100%;
  background: #333;
  margin-top: 20px;
}
.footer {
  text-align: center;
  line-height: 40px;
  color: #fff;
  padding: 8px;
  overflow: hidden;
}
#logosearch {
  width: 100%;
  /* border-bottom: 2px solid #409eff; */
  box-sizing: border-box;
}
.leftnav {
  width: 210px;
  position: absolute;
  z-index: 31;
  height: 392px;
  padding-top: 10px;
  left: 0;
  top: -2px;
  background: rgba(0, 0, 0, 0.7);
}
.leftnav a {
  display: block;
  height: 60px;
  padding-left: 30px;
  line-height: 60px;
  color: #fff;
  position: relative;
}
.leftnav a:hover {
  background: #fff;
  color: #000;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
}
.leftnav .leftnavname {
  transition: text-indent 0.3s;
}
.leftnav .leftnavname:hover {
  text-indent: 10px;
}
.leftnav a > span {
  display: block;
}
.leftnav .childbox {
  position: absolute;
  left: 210px;
  top: 0;
  z-index: 23;
  cursor: auto;
  width: 990px;
  min-height: 400px;
  background: #fff;
  border: 1px solid #eee;
  border-left: none;
  box-sizing: border-box;
}
.leftnav .childbox0 {
  top: -10px;
}
.leftnav .childbox1 {
  top: -70px;
}
.leftnav .childbox2 {
  top: -130px;
}
.leftnav .childbox3 {
  top: -190px;
}
.leftnav .childbox4 {
  top: -250px;
}
.leftnav .childbox5 {
  top: -310px;
}
.leftnav .childbox6 {
  top: -370px;
}
.leftnav .childbox7 {
  top: -430px;
}
.leftnav .childbox li {
  overflow: hidden;
  padding: 20px;
}
.leftnav .childbox li:last-child .zzfl {
  border: none;
}
.leftnav .childbox h3 {
  display: block;
  line-height: 24px;
  width: 120px;
  float: left;
  cursor: pointer;
}
.leftnav .childbox h3:hover {
  color: #409eff;
}
.leftnav .childbox .zzfl {
  line-height: 24px;
  width: 820px;
  float: right;
  border-bottom: 1px solid #eee;
}
.leftnav .childbox .zzfl a {
  cursor: pointer;
  color: #333;
  border-left: 1px solid #eee;
  line-height: 24px;
  margin-bottom: 10px;
  padding: 0 10px;
  height: auto;
  display: inline-block;
}
.leftnav .childbox .zzfl a:hover {
  color: #e6a23c;
  border-top: none;
  border-bottom: none;
}
.rightnav {
  width: 220px;
  position: absolute;
  z-index: 25;
  height: 302px;
  padding-top: 10px;
  right: 0;
  top: 43px;
  background: white;
}
.rightnav .box1 {
  padding: 10px 15px;
}
.rightnav .img1 {
  width: 40px;
  height: 40px;
  position: absolute;cursor: pointer;
}
.rightnav .nameText {
  margin-left: 48px;
  color: #333;
  display: inline-block;cursor: pointer;
  width: 96px;
  vertical-align: middle;
  line-height: 1.5;
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  margin-top: 10px;
}
.rightnav .backText {
  color: #999;
  vertical-align: middle;
  line-height: 1.5;
  margin-left: 5px;
  margin-top: 10px;
  display: inline-block;
  cursor: pointer;
}
.rightnav .inner1 {
  margin-top: 20px;
  height: 180px;
  overflow: hidden;
  /* display: flex;
  justify-content: space-between; */
}
.rightnav .personcount {
  display: flex;
  justify-content: space-between;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #ebebeb;
}
.rightnav .personcount .text1 {
  display: inline;
}
/* .rightnav .inner1 li{padding-top: 11px;overflow: hidden;
text-overflow:ellipsis;cursor: pointer;
white-space: nowrap;}
.rightnav .inner1 li:hover{color: #409eff;} */
.rightnav .inner1 .li {
  background: #f6f6f6;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 15px;
  padding: 8px;
}
.rightnav .inner1 .li .left {
  float: left;
}
.rightnav .inner1 .li .left > div {
  width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rightnav .inner1 .li .left .name {
  padding-bottom: 4px;
}
.rightnav .inner1 .li .left .comp {
  font-size: 12px;
  color: #8a898b;
}
.rightnav .inner1 .li .right {
  float: right;
}
.rightnav .inner1 .li .right button {
  padding: 7px;
  margin-top: 6px;
}
.loginBtn {
  width: 90%;
  margin-left: 5%;
  position: absolute;
  bottom: 10px;
}
.allclass {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 210px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #409eff;
  color: #fff;
  z-index: 30;
  cursor: pointer;
}
.topnav {
  position: absolute;
  left: 210px;
  bottom: 0;
  width: 700px;
  z-index: 30;
  height: 40px;
  line-height: 40px;
}
.topnav a {
  padding: 0px 20px;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
}
.topnav a:first-child {
  color: #f56c6c;
}
.logined {
  display: flex;
}
.logined > span {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.logined > span img {
  margin-right: 4px;
}
.nav {
  background: #58b57c;
  height: 50px;
  line-height: 50px;
}
.nav > div {
  overflow: hidden;
}
.nav a {
  font-size: 17px;
  color: #fff;
  font-weight: bold;
  padding: 0 25px;
  display: block;
  float: left;
}
.nav a:hover,
.nav .on {
  background: #0ac587;
}
.noticebox h3 {
  border-bottom: 1px solid #ddd;
  text-align: center;
  padding-bottom: 10px;
}
.noticebox li {
  padding: 5px 0;
  border-bottom: 1px solid #ebebeb;
}
.noticebox .up,
.noticebox .down {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
}
.noticebox .up .img {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: #2977ee;
  text-align: center;
}
/* #58B57C
#F19302 */
.noticebox .up img {
  height: 16px;
  margin-top: 8px;
}
.noticebox .up p {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.noticebox .up span {
  font-size: 12px;
  color: #999;
}
.noticebox .down p {
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666;
  font-size: 12px;
}
.noticebox .down a {
  color: #2977ee;
  font-size: 12px;
}
.noticebox .down a:hover {
  color: #609eff;
}
.noticebox button {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;
}
.reglog span {
  line-height: 40px;
  cursor: pointer;
}
.instructionshadow {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 222;
  background: rgba(0, 0, 0, 0.4);
}
.instructionshadow > div {
  position: fixed;
  top: 100px;
  left: 50%;
  margin-left: -300px;
  width: 700px;
  background: #ffffff;
  border-radius: 16px;
}
.instructionshadow .title {
  width: inherit;
  height: 80px;
  line-height: 80px;
  background: url('~@/assets/img/instructionstt.png') no-repeat;
  background-size: 100%;
  text-align: center;
  color: #fff;
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: bold;
  position: relative;
}
.instructionshadow .title img {
  position: absolute;
  right: 20px;
  top: 24px;
  cursor: pointer;
  padding: 10px;
}
.localtion a{color: #2977ee;cursor: pointer;}
.localtion a:hover{text-decoration: underline;}
</style>
